import { render, staticRenderFns } from "./shipDashboard.vue?vue&type=template&id=24dd4468&scoped=true"
import script from "./shipDashboard.vue?vue&type=script&lang=js"
export * from "./shipDashboard.vue?vue&type=script&lang=js"
import style0 from "./shipDashboard.vue?vue&type=style&index=0&id=24dd4468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd4468",
  null
  
)

export default component.exports